import { render, staticRenderFns } from "./index.vue?vue&type=template&id=daca4cf6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=daca4cf6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daca4cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daca4cf6')) {
      api.createRecord('daca4cf6', component.options)
    } else {
      api.reload('daca4cf6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=daca4cf6&scoped=true", function () {
      api.rerender('daca4cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/right/hotspotCoutoutStyle/index.vue"
export default component.exports